// Web Audio ile üretilen basit ses efektleri; harici ses dosyası yok.
let ctx = null;

export const sfx = {
  enabled: false,
  enable() {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    ctx.resume();
    sfx.enabled = true;
  },
  disable() {
    sfx.enabled = false;
    if (ctx) ctx.suspend();
  },
  tone(freq, dur, { type = "sine", gain = 0.15, delay = 0, slideTo } = {}) {
    if (!sfx.enabled || !ctx) return;
    const t = ctx.currentTime + delay;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = type;
    o.frequency.setValueAtTime(freq, t);
    if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, t + dur);
    g.gain.setValueAtTime(gain, t);
    g.gain.exponentialRampToValueAtTime(0.001, t + dur);
    o.connect(g).connect(ctx.destination);
    o.start(t);
    o.stop(t + dur + 0.02);
  },
  clack(delay) {
    sfx.tone(2200, 0.018, { type: "square", gain: 0.05, delay });
    sfx.tone(320, 0.05, { type: "triangle", gain: 0.12, delay, slideTo: 160 });
  },
  tick(high) { sfx.tone(high ? 1250 : 900, 0.07, { type: "square", gain: 0.07 }); },
  // Çark: her dilim sınırında bir "tık" (zamanlar çarkın yavaşlamasına göre hesaplanır) + duruş sesi
  wheel(times, sec = 5) {
    sfx.tone(180, 0.6, { type: "sawtooth", gain: 0.05, slideTo: 520 });
    times.forEach((t) => sfx.clack(t));
    [784, 988, 1175].forEach((f, i) => sfx.tone(f, 0.35, { type: "triangle", gain: 0.12, delay: sec + 0.05 + i * 0.09 }));
  },
  join() { [880, 1319].forEach((f, i) => sfx.tone(f, 0.3, { type: "sine", gain: 0.1, delay: i * 0.11 })); sfx.tone(1760, 0.25, { type: "triangle", gain: 0.04, delay: 0.22 }); },
  bankrupt() { [392, 330, 262, 196].forEach((f, i) => sfx.tone(f, 0.42, { type: "sawtooth", gain: 0.08, delay: i * 0.32, slideTo: f * 0.94 })); },
  pass() { [523, 392].forEach((f, i) => sfx.tone(f, 0.25, { type: "triangle", gain: 0.12, delay: i * 0.18 })); },
  wrong() { sfx.tone(220, 0.35, { type: "square", gain: 0.07, slideTo: 140 }); },
  result() { [523, 659, 784].forEach((f, i) => sfx.tone(f, 0.28, { gain: 0.12, delay: i * 0.1 })); },
  streak() { [660, 880, 1320].forEach((f, i) => sfx.tone(f, 0.2, { type: "sawtooth", gain: 0.06, delay: i * 0.08 })); },
  draw() {
    for (let i = 0; i < 8; i += 1) sfx.tone(700 + i * 90, 0.05, { type: "triangle", gain: 0.06, delay: i * 0.06 });
    sfx.tone(988, 0.35, { gain: 0.12, delay: 0.55 });
  },
};
